import { Images } from '@/assets';
import CommonTitle from '@/components/title/CommonTitle';
import styled from 'styled-components';
import OrderCategory from './order-category/OrderCategory';
import { GetPartnerServiceOptionsResponse } from '@/api/type/types';
import { useTranslation } from 'react-i18next';
import RoleExplain from './role-explain/RoleExplain';

interface R2PlayerRegistationProps {
  data: GetPartnerServiceOptionsResponse[];
}
const R2PlayerRegistation = ({ data }: R2PlayerRegistationProps) => {
  const crownBridgeData = data.find(
    (item) => item.serviceType === 'CROWN_BRIDGE'
  );
  const { t } = useTranslation();

  const r2GuideData = data.find(
    (item) => item.serviceType === 'SURGICAL_GUIDE'
  );

  return (
    <Container>
      <TitleWrap>
        <CommonTitle
          imgUrl={Images.NavServiceAddIcon}
          title={t('addProductService')}
        />
      </TitleWrap>
      <ContentsSection>
        <RoleExplain />
        <CategorySection>
          <OrderCategory
            imgUrl={Images.CrownBridgeImg}
            data={crownBridgeData}
            title="Crown & Bridge"
            serviceType={'CROWN_BRIDGE'}
            desc={t(
              'registerVariousManufacturingAndDesignServicesSuchAsCrownsInlaysOnlaysAndImplantProsthetics'
            )}
          />
          <OrderCategory
            imgUrl={Images.R2GuideImg}
            title="R2 Guide"
            data={r2GuideData}
            serviceType={'SURGICAL_GUIDE'}
            desc={t('oneDayImplantServicesWithR2GateDiagnosis')}
          />
        </CategorySection>
      </ContentsSection>
    </Container>
  );
};

export default R2PlayerRegistation;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30.5px;
`;

const ContentsSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 13px;
`;

const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-left: 61px;
`;
